var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { forwardRef } from 'react';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import CloseIcon from '@mui/icons-material/Close';
import { cn } from 'root/src/client/v2/common/helpers/cn';
export const Dialog = DialogPrimitive.Root;
export const DialogTrigger = DialogPrimitive.Trigger;
export const DialogPortal = DialogPrimitive.Portal;
export const DialogClose = DialogPrimitive.Close;
export const DialogOverlay = forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (<DialogPrimitive.Overlay ref={ref} className={cn('fixed inset-0 z-[1100] bg-black/80 data-[state=open]:animate-dialog-overlay-show data-[state=closed]:animate-dialog-overlay-hide', className)} {...props}/>);
});
DialogOverlay.displayName = DialogPrimitive.Overlay.displayName;
export const DialogContent = forwardRef((_a, ref) => {
    var { className, overlayClassName, children } = _a, props = __rest(_a, ["className", "overlayClassName", "children"]);
    return (<DialogPortal>
		<DialogOverlay className={overlayClassName}/>
		<DialogPrimitive.Content ref={ref} className={cn(
        // `w-[calc(100vw-2rem)]` keeps a 1rem gutter on mobile (never edge-to-edge / no horizontal
        // overflow); `max-w-lg` (or a per-dialog override) caps it on larger screens.
        'redesign fixed left-[50%] top-[50%] z-[1101] grid w-[calc(100vw-2rem)] max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border border-border bg-background p-6 text-foreground shadow-lg sm:rounded-lg data-[state=open]:animate-dialog-content-show data-[state=closed]:animate-dialog-content-hide', className)} {...props}>
			{children}
			<DialogPrimitive.Close className="absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-muted-foreground focus:ring-offset-2 disabled:pointer-events-none">
				<CloseIcon sx={{ fontSize: 16 }}/>
				<span className="sr-only">Close</span>
			</DialogPrimitive.Close>
		</DialogPrimitive.Content>
	</DialogPortal>);
});
DialogContent.displayName = DialogPrimitive.Content.displayName;
export const DialogHeader = (_a) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (<div className={cn('flex flex-col space-y-1.5 text-center sm:text-left', className)} {...props}/>);
};
DialogHeader.displayName = 'DialogHeader';
export const DialogFooter = (_a) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (<div className={cn('flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2', className)} {...props}/>);
};
DialogFooter.displayName = 'DialogFooter';
export const DialogTitle = forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (<DialogPrimitive.Title ref={ref} className={cn('text-lg font-semibold leading-none tracking-tight', className)} {...props}/>);
});
DialogTitle.displayName = DialogPrimitive.Title.displayName;
export const DialogDescription = forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (<DialogPrimitive.Description ref={ref} className={cn('text-sm text-muted-foreground', className)} {...props}/>);
});
DialogDescription.displayName = DialogPrimitive.Description.displayName;
